import { Container, Link } from "@material-ui/core";
import React from "react";
import ContentList from "../../components/contentList";
import ContentForm from "./contentForm";

export default function ContactContent() {
  return (
    <Container>
      <ContentList
        title="CORPORATE OFFICE:"
        items={[
          "#8 Gallus Street, Woodbrook, Trinidad and Tobago",
          "yooz@yoozit.today",
          "+1 (868) 235-6182",
        ]}
      />
      <ContentList
        title="CUSTOMER CARE OPERATING HOURS:"
        items={["Monday to Friday", "8am to 5pm"]}
      />
      <ContentList
        title="SOCIAL MEDIA:"
        items={[
          <Link
            href="https://www.facebook.com/yoozpay/"
            target="_blank"
            color="secondary"
          >
            Facebook
          </Link>,
          <Link
            href="https://www.instagram.com/yooz.tt/?hl=en"
            target="_blank"
            color="secondary"
          >
            Instagram
          </Link>,
          <Link
            href="https://www.youtube.com/channel/UCKD0DpvEBnDLZc1Z71vfMHg"
            target="_blank"
            color="secondary"
          >
            Youtube
          </Link>,
        ]}
      />
      <ContentList title="MESSAGE US:" items={[<ContentForm />]} />
    </Container>
    // <Container maxWidth="lg">
    //   <ContentList
    //     title="CORPORATE OFFICE:"
    //     list={
    //       <TextList
    //         items={[
    //           "1 Luis Street, Woodbrook, Trinidad, West Indies",
    //           "yooz@resonancecaribbean.com",
    //           "+1 (868) 235-6182",
    //         ].map((text) => (
    //           <Typography variant={md ? "h5" : "body1"}>{text}</Typography>
    //         ))}
    //       />
    //     }
    //   />
    //   <ContentList
    //     title="CUSTOMER CARE OPERATING HOURS:"
    //     list={
    //       <TextList
    //         items={[
    //           "Monday to Friday",
    //           "8am to 5pm",
    //         ].map((text) => (
    //           <Typography variant={md ? "h5" : "body1"}>{text}</Typography>
    //         ))}
    //       />
    //     }
    //   />
    //   <ContentList
    //     title="SOCIAL MEDIA:"
    //     list={
    //       <TextList
    //         items={[
    //             <Link
    //               href="https://www.facebook.com/yoozpay/"
    //               target="_blank"
    //               color="secondary"
    //             >
    //               Facebook
    //             </Link>,
    //             <Link
    //               href="https://www.instagram.com/yooz.tt/?hl=en"
    //               target="_blank"
    //               color="secondary"
    //             >
    //               Instagram
    //             </Link>,
    //             <Link
    //               href="https://www.youtube.com/channel/UCKD0DpvEBnDLZc1Z71vfMHg"
    //               target="_blank"
    //               color="secondary"
    //             >
    //               Youtube
    //             </Link>
    //         ].map((text) => (
    //           <Typography variant={md ? "h5" : "body1"}>{text}</Typography>
    //         ))}
    //       />
    //     }
    //   />
    //   <ContentForm
    //     title="MESSAGE US:"
    //   />

    // </Container>
  );
}
